import BookingOrder from './booking-order';

export default BookingOrder;